export const BEARING = 'bearing';
export const DISTANCE = 'distance';
export const LOCATION_ID = 'location-id';
